<app-breadcrumb></app-breadcrumb>

<app-error-state
  [title]="texts.title"
  [description]="subtitle"
  [canRetry]="canRetry"
  [retrying]="isRetrying"
  (retry)="retry()"
  (goHome)="goHome()"
></app-error-state>
